<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 w-full">
      <vx-card>
        <form autocomplete="off">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/sbt-caravanas-logo.png"
                  alt="login"
                  class="w-1/2 m-auto"
                />
              </div>

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg w-full">
                <div class="login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Altere a sua senha</h4>
                  </div>

                  <div>
                    <vs-row>
                      <vs-col
                        ><vs-input
                          name="new-password"
                          id="password1"
                          type="number"
                          v-mask="'####'"
                          pattern="[0-9]*"
                          label-placeholder="Nova senha"
                          v-model="newPassword"
                          class="w-full mt-6 password-input"
                          maxlength="4"
                          data-vv-as="'Nova senha'"
                          v-validate="'required|digits:4'"
                          ref="password"
                      /></vs-col>
                    </vs-row>
                    <vs-row v-show="errors.has('new-password')">
                      <vs-col>
                        <span
                          class="text-danger text-sm"
                          id="new-password-error"
                          v-show="errors.has('new-password')"
                          >{{ errors.first('new-password') }}</span
                        >
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col
                        ><vs-input
                          name="confirm-password"
                          id="password2"
                          type="number"
                          v-mask="'####'"
                          pattern="[0-9]*"
                          label-placeholder="Confirme a nova senha"
                          v-model="confirmPassword"
                          class="w-full mt-10 password-input"
                          maxlength="4"
                          data-vv-as="'Confirme a nova senha'"
                          v-validate="'required|digits:4|confirmed:password'"
                      /></vs-col>
                    </vs-row>
                    <vs-row v-show="errors.has('confirm-password')">
                      <vs-col>
                        <span
                          class="text-danger text-sm"
                          id="confirm-password-error"
                          >{{ errors.first('confirm-password') }}</span
                        >
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-5" v-show="error">
                      <vs-col>
                        <span class="text-danger text-sm" id="password">{{
                          error
                        }}</span>
                      </vs-col>
                    </vs-row>
                    <div class="flex flex-wrap justify-end my-5">
                      <!-- <router-link class="self-end" to=""
                      >Esqueci a senha</router-link
                    > -->
                      <vs-button
                        @click="changePassword"
                        :disabled="!isButtonReady"
                        id="button-with-loading"
                        class="float-right"
                        >Próximo</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import Vue from 'vue'
import { strings } from '@/utils/strings'
import { mask } from 'vue-the-mask'

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      error: null,
    }
  },
  directives: { mask },
  computed: {
    isButtonReady() {
      return this.isFormValid
    },
    isFormValid() {
      return !this.errors.any() && this.confirmPassword && this.newPassword
    },
  },
  methods: {
    openLoadingContained() {
      this.$vs.loading({
        background: 'primary',
        color: '#FFF',
        container: '#button-with-loading',
        scale: 0.45,
      })
      this.isLoadingActive = true
    },
    closeLoadingContained() {
      this.$vs.loading.close('#button-with-loading > .con-vs-loading')
      this.isLoadingActive = false
    },
    changePassword() {
      this.openLoadingContained()
      let password = this.newPassword + '=='
      Vue.prototype.$Amplify.Auth.completeNewPassword(
        this.user,
        password,
        this.user.challengeParam.requiredAttributes
      )
        .then(() => {
          this.$router.push({ name: 'home' }).catch((err) => {})
        })
        .catch((error) => {
          this.closeLoadingContained()
          this.error = 'Erro ao alterar a senha. Descrição: ' + error
        })
    },
  },
  mounted() {
    if (!this.user) {
      this.$router.push({ name: 'page-login' }).catch((err) => {})
    }
  },
}
</script>

<style lang="scss"></style>
